export default __webpack_public_path__ + "static/media/top_right.1809c770.png";